"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationCard = NavigationCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const server_1 = require("@kalkulacka-one/design-system/server");
function NavigationCard({ children }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: "koa:@container koa:grid koa:justify-items-end koa:m-2 koa:sm:m-3 koa:lg:m-4", children: (0, jsx_runtime_1.jsx)(server_1.Card, { corner: "bottomRight", shadow: "elevated", className: "koa:border koa:border-slate-200 koa:pointer-events-auto", children: (0, jsx_runtime_1.jsx)("div", { className: "koa:p-3 koa:sm:p-4 koa:grid koa:grid-flow-row koa:gap-2 koa:sm:gap-3", children: children }) }) }));
}
